import React from "react";
import TableOfContentsItem from "./TableOfContentsItem";

function TableOfContentsList({ items }) {
  if (!items || items.length === 0) return null;

  const getItemId = (item) => {
    return item?.id ?? item?.href ?? new URLSearchParams(item?.msPath?.split('?')[1] || "").get("sectionId");
  };

  return (
    <ul>
      {items.map((item) => (
        <TableOfContentsItem key={getItemId(item)} item={item} />
      ))}
    </ul>
  );
}

export default TableOfContentsList;